<template>
    <div class="x-dynamic-tag">
        <el-tag
            v-for="tag in dynamicTags"
            :key="tag"
            class="mx-1"
            :closable="!readonly"
            :disable-transitions="false"
            @close="handleClose(tag)"
        >
            {{ tag }}
        </el-tag>
        <el-input
            v-if="inputVisible && !readonly"
            ref="input"
            v-model="inputValue"
            class="ml-1 w-20"
            size="small"
            @keyup.enter="handleInputConfirm"
            @blur="handleInputConfirm"
        />
        <el-button v-else-if="!readonly" class="button-new-tag ml-1" size="small" @click="showInput">+ 添加</el-button>
    </div>
</template>
<script setup>
import { defineProps, getCurrentInstance, nextTick, ref, watch } from 'vue';

const inst = getCurrentInstance();

const props = defineProps({
    config: { default: null },
    readonly: { default: false },
    modelValue: { default: null },
    data: { default: null },
    field: { default: null },
})

defineEmits({
    'update:modelValue': null,
})

const inputValue = ref('');
const dynamicTags = ref([]);
const inputVisible = ref(false);
watch(()=> props.modelValue, (value)=> {
    dynamicTags.value = value ? value.split(/\s*\,\s*/) : [];
}, {immediate:true});

const handleClose = (tag) => {
  dynamicTags.value.splice(dynamicTags.value.indexOf(tag), 1)
  inst.emit('update:modelValue', dynamicTags.value.join(','));
}

const showInput = () => {
  inputVisible.value = true
  nextTick(() => {
    inst.refs.input['input'].focus();
  })
}

const handleInputConfirm = () => {
  if (inputValue.value) {
    dynamicTags.value.push(inputValue.value);
    inst.emit('update:modelValue', dynamicTags.value.join(','));
  }
  inputVisible.value = false
  inputValue.value = ''
}

</script>